import React from "react"

const image = ({ name, selector } = {}) => ({
  name,
  type: "image",
  component: ({ name: _name, value, onChange }) => {
    return (
      <div>
        <input type="text" value={value} onChange={onChange} />
      </div>
    )
  },
  css: value => {
    return `
      ${selector} {
        background-image: url('${value}');
      }
    `
  }
})

export default image
